import { Heading } from '@backend/lib-design-system';
import { styled } from 'styled-components';

import { FooterMenuItem } from '~/components/Footer/footerMenuItem';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useGetDomainPublicUrl, useTranslation } from '~/hooks';
import { getMediaQuery } from '~/utils/responsive/media';

export const StyledFooterMenu = styled.div`
  display: flex;
  gap: 16px;

  ${getMediaQuery('mobile')} {
    flex-direction: column;
    text-align: center;
  }
`;

export const StyledFooterMenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const StyledFooterMenuColumnList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FooterMenu = () => {
  const t = useTranslation();
  const getPublicUrl = useGetDomainPublicUrl();
  const { businessUnit } = useBusinessUnitContext();

  return (
    <StyledFooterMenu>
      <StyledFooterMenuColumn>
        <Heading variant="heading-4">{t('footer.worker')}</Heading>
        <StyledFooterMenuColumnList>
          <FooterMenuItem href={getPublicUrl('why')}>{t('footer.why')}</FooterMenuItem>
        </StyledFooterMenuColumnList>
      </StyledFooterMenuColumn>
      <StyledFooterMenuColumn>
        <Heading variant="heading-4">{t('footer.companies')}</Heading>
        <StyledFooterMenuColumnList>
          <FooterMenuItem href={getPublicUrl('companySpace')}>{t('footer.companySpace')}</FooterMenuItem>
          <FooterMenuItem
            href={`https://entreprise.iziwork.com/${t('url.askADemo')}/?utm_source=site_iziwork&utm_campaign=footer`}
          >
            {t('footer.askADemo')}
          </FooterMenuItem>
          {businessUnit === 'FR' && (
            <FooterMenuItem href="https://pro.iziwork.com/">{t('footer.account')}</FooterMenuItem>
          )}
        </StyledFooterMenuColumnList>
      </StyledFooterMenuColumn>
      {businessUnit === 'FR' && (
        <StyledFooterMenuColumn>
          <Heading variant="heading-4">{t('footer.partners')}</Heading>
          <StyledFooterMenuColumnList>
            <FooterMenuItem href={getPublicUrl('partners')}>{t('footer.program')}</FooterMenuItem>
          </StyledFooterMenuColumnList>
        </StyledFooterMenuColumn>
      )}
      <StyledFooterMenuColumn>
        <Heading variant="heading-4">{t('footer.aboutUs')}</Heading>
        <StyledFooterMenuColumnList>
          <FooterMenuItem href={getPublicUrl('who')}>{t('footer.who')}</FooterMenuItem>
          <FooterMenuItem href={getPublicUrl('blog')}>{t('footer.blog')}</FooterMenuItem>
          <FooterMenuItem href={getPublicUrl('press')}>{t('footer.press')}</FooterMenuItem>
        </StyledFooterMenuColumnList>
      </StyledFooterMenuColumn>
    </StyledFooterMenu>
  );
};
